import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { TabMenu } from 'primereact/tabmenu';
import { InputTextarea } from 'primereact/inputtextarea';
import { PickList } from 'primereact/picklist';
import { Divider } from 'primereact/divider';
import { confirmDialog } from 'primereact/confirmdialog';

import { SplitButton } from 'primereact/splitbutton';

import CategoriesSectionTree from '@components/CategorieSectionTree';
import JustificationModal from '@components/JustificationModal';

import { generateLayoutsHtml } from '@actions/sections';
import { validatePermissionAction } from '@actions/sessionPermission';

import { catalogoClass } from '@constants/seccion';
import { SET_VALUES_SECTION } from '@constants/actionType';
import { LANGUAGE_DEFAULT, AuthorizedStatus, SECTION_HOME_ID } from '@constants/general';
import catalogPermissionsId from '@constants/catalogPermissionsId'


import store from '@store';

import './style.scss'

const MAX_SECTIONTS = 4

const ID_SECTION_DOCUMENTS = 10
const COMPONENT_CATEGORY_DOCUMENTS = "DocumentsCards"
const COMPONENT_FILTER_DOCUMENTS = "isFilterComponent"

class GeneralForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedNavegationTree: '',
      selectedLabelNavegationTree: '',
      activeTabIndex: 0,
      loadingPage: true,
      componentsAvailables: [],
      componentsSelected: [],
      isLanding: true,
      errors: {},
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
    };
    this.initialValuesForm = {
      titleSeccion: '',
      // description: '',
    };
    this.itemTemplate = this.itemTemplate.bind(this);
    this.actions = [
      {
        label: this.props.t('Cancelar'),
        command: (e) => {}
      }
    ]
  }

  componentDidMount() {
    const {
      keysLenguages,
      _general,
      _componentsAvailables,
      _componentsSelected,
      history,
      _selectedNavegationTree,
      isEdit
    } = this.props;

    if (history.location?.state?.selectedNavegationTree) {
      this.setState({selectedNavegationTree: history.location?.state?.selectedNavegationTree})
    }

    if (_general) {
      let validateComponentsAvailables = _componentsAvailables
      if (isEdit) validateComponentsAvailables = this.validateComponentAvailablesEditSection(validateComponentsAvailables)
      this.setState({selectedNavegationTree: _selectedNavegationTree})

      this.setState({
        ..._general,
        componentsAvailables: validateComponentsAvailables,
        componentsSelected: _componentsSelected,
      });
    } else {
      keysLenguages.map((item) =>
        this.setState({ [item]: { ...this.initialValuesForm } })
      );
      // const newComponentsAvailables = catalogoClass.filter((item => item.parentClass.class !== 'sct-category'))
      const {componentsAvailables, componentsSelected} = this.validateComponentNewSection()
      this.setState({
        componentsAvailables,
        componentsSelected
      })
    }
    this.validateOptionsSlit()

    this.setState({ loadingPage: false });
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.selectedLabelNavegationTree != this.state.selectedLabelNavegationTree) {
      const dividerSectionParent = this.state.selectedLabelNavegationTree.split("/")
      this.setState({isLanding: dividerSectionParent.length < MAX_SECTIONTS})
    }
    if (prevState.selectedNavegationTree !== this.state.selectedNavegationTree) {
      if (this.state.selectedNavegationTree === ID_SECTION_DOCUMENTS) {
        const existFilterDocuments = this.state.componentsSelected.find(item => item.componentName === COMPONENT_FILTER_DOCUMENTS)
        if (!existFilterDocuments) {
          const componentFiterdocument = catalogoClass.find(item => item.componentName === COMPONENT_FILTER_DOCUMENTS )
          const componentsSelected = this.state.componentsSelected
          componentsSelected.push(componentFiterdocument)
          this.setState({componentsSelected})
        }
      } else {
        // Para eliminar documentos en caso de que este en otro nivel
        const existFilterDocuments = this.state.componentsSelected.find(item => item.componentName === COMPONENT_FILTER_DOCUMENTS)
        if (existFilterDocuments) {
          const componentFiterdocument = this.state.componentsSelected.filter(item => item.componentName !== COMPONENT_FILTER_DOCUMENTS )
          this.setState({componentsSelected: componentFiterdocument})
        }
      }
    }
  }

  validateOptionsSlit = () => {
    const { isEdit, validatePermissionAction, estatusSection } = this.props
    if (isEdit) {
      // @Editar seccion
      if (estatusSection !== AuthorizedStatus.STATUS_AUTHORIZED) {
        const canDeleteVersion = validatePermissionAction(catalogPermissionsId.ELIMINAR_SECCION)
        if (canDeleteVersion) {
          this.actions.unshift({
            label: this.props.t('Eliminar Version'),
            icon: 'pi pi-times',
            command: () => {
              this.props.deleteVersion()
            }
          })
        }
        const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_RECHAZAR_PUBLICACION_DE_SECCION)
        if (hasAuthorized) {
          if (estatusSection !== AuthorizedStatus.STATUS_REJECTED) {
            this.actions.unshift({
              label: this.props.t('Rechazar'),
              icon: 'pi pi-exclamation-triangle',
              command: () => {
                this.props.reject()
              }
            })
          }
          this.actions.unshift({
            label: this.props.t('Autorizar'),
            icon: 'pi pi-check-circle',
            command: () => {
              this.onSubmit(null, (justification) => this.props.authorize(false, justification))
            }
          })
        } else {
          if (estatusSection !== AuthorizedStatus.STATUS_PENDING) {
            this.actions.unshift({
              label: this.props.t('Enviar a autorizar'),
              icon: 'pi pi-envelope',
              command: () => {
                this.onSubmit(null, (justification) => this.props.sendAuthorize(false, justification))
              }
            })
          }
        }
      }






    } else {
      // @Nueva seccion
      const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_RECHAZAR_PUBLICACION_DE_SECCION)
      if (hasAuthorized) {
        this.actions.unshift({
          label: this.props.t('Autorizar'),
          icon: 'pi pi-users',
          command: () => {
            this.onSubmit(null, (justification) => this.props.authorize(false, justification))
          }
        })
      } else {
        this.actions.unshift({
          label: this.props.t('Enviar a autorizar'),
          icon: 'pi pi-users',
          command: () => {
            this.onSubmit(null, (justification) => this.props.sendAuthorize(false, justification))
          }
        })
      }
    }
  }

  validateActionOnlyFilterDocument = () => {
    const { isEdit, validatePermissionAction, estatusSection } = this.props
    const actionsOnlyFilterDocument = [
      {
        label: this.props.t('Cancelar'),
        command: (e) => {}
      }
    ]
    if (isEdit) {
      // @Editar seccion
      if (estatusSection !== AuthorizedStatus.STATUS_AUTHORIZED) {
        const canDeleteVersion = validatePermissionAction(catalogPermissionsId.ELIMINAR_SECCION)
        if (canDeleteVersion) {
          actionsOnlyFilterDocument.unshift({
            label: this.props.t('Eliminar Version'),
            icon: 'pi pi-times',
            command: () => {
              this.props.deleteVersion()
            }
          })
        }
        const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_RECHAZAR_PUBLICACION_DE_SECCION)
        if (hasAuthorized) {
          if (estatusSection !== AuthorizedStatus.STATUS_REJECTED) {
            actionsOnlyFilterDocument.unshift({
              label: this.props.t('Rechazar'),
              icon: 'pi pi-exclamation-triangle',
              command: () => {
                this.props.reject()
              }
            })
          }
          actionsOnlyFilterDocument.unshift({
            label: this.props.t('Autorizar'),
            icon: 'pi pi-check-circle',
            command: () => {
              this.onSubmit(null, (justification) => this.sendIsOnlyFilterDocument(this.props.authorize, justification), true)
            }
          })
        } else {
          if (estatusSection !== AuthorizedStatus.STATUS_PENDING) {
            actionsOnlyFilterDocument.unshift({
              label: this.props.t('Enviar a autorizar'),
              icon: 'pi pi-envelope',
              command: () => {
                this.onSubmit(null, (justification) => this.sendIsOnlyFilterDocument(this.props.sendAuthorize, justification), true)

              }
            })
          }
        }
      }
    } else {
      // @Nueva seccion
      const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_RECHAZAR_PUBLICACION_DE_SECCION)
      if (hasAuthorized) {
        actionsOnlyFilterDocument.unshift({
          label: this.props.t('Autorizar'),
          icon: 'pi pi-users',
          command: () => {
            // this.saveSection(this.props.authorize)
            this.onSubmit(null, (justification) => this.sendIsOnlyFilterDocument(this.props.authorize, justification), true)
          }
        })
      } else {
        actionsOnlyFilterDocument.unshift({
          label: this.props.t('Enviar a autorizar'),
          icon: 'pi pi-users',
          command: () => {
            // this.saveSection(this.props.sendAuthorize)
            this.onSubmit(null, (justification) => this.sendIsOnlyFilterDocument(this.props.sendAuthorize, justification), true)
          }
        })
      }
    }
    return actionsOnlyFilterDocument
  }

  validateComponentNewSection = () => {
    let componentsAvailables = []
    const componentsSelected = []
    componentsAvailables = catalogoClass.filter(item => item.componentName !== COMPONENT_CATEGORY_DOCUMENTS)
    componentsAvailables = componentsAvailables.filter(item => item.componentName !== COMPONENT_FILTER_DOCUMENTS)
    return { componentsAvailables, componentsSelected }
  }

  validateComponentAvailablesEditSection = (components) => {
    let componentsAvailables =  []
    componentsAvailables = components.filter(item => item.componentName !== COMPONENT_CATEGORY_DOCUMENTS)
    componentsAvailables = componentsAvailables.filter(item => item.componentName !== COMPONENT_FILTER_DOCUMENTS)
    return componentsAvailables
  }

  onChangeCategoriesSection = ({ value, label }) => {
    this.setState({
      selectedNavegationTree: value,
      selectedLabelNavegationTree: label,
    }, () => this.validateFieldsOnchange('selectedNavegationTree', value));
  };

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { t } = this.props
    const { componentsSelected, selectedNavegationTree, isLanding, isEdit } = this.state
    const { titleSeccion, description } = this.state[LANGUAGE_DEFAULT]
    let errors = {}
    if (!titleSeccion) errors = {...errors, [`${LANGUAGE_DEFAULT}-titleSeccion`]: `${t('Titulo')} ${t('es requerido')}`}
    // if (!description) errors = {...errors, [`${LANGUAGE_DEFAULT}-description`]: `${t('Descripción')} ${t('es requerido')}`}
    if (isLanding) {
      // if (!componentsSelected.length) errors = {...errors, [`componentsSelected`]: `${t('Debés seleccionar un componente disponible')}`}
      if (!selectedNavegationTree && isEdit) errors = {...errors, [`selectedNavegationTree`]: `${t('Sección Padre')} ${t('es requerido')}`}
    }
    this.setState({errors})
    return errors
  }

  onSubmit = async (e, action, sendAction = false) => {
    if (e) e.preventDefault();
    const { isLanding, componentsSelected } = this.state
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    const { success, t } = this.props;
    await this.setValuesToStateGlobal();
    if (sendAction){
      // action()
      this.onConfirmAction(action)
    } else if (isLanding) {
      if (!componentsSelected.length) {
        confirmDialog({
          message: t('Deseas continuar sin componentes seleccionados'),
          header: t('Confirmación'),
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: t('Continuar'),
          rejectLabel: t('Cancelar'),
          // rejectClassName: 'hide-component',
          accept: () => success(),
          onHide: () => {}
        });
      } else {
        success();
      }
    } else {
      this.onConfirmAction(action)
      // action()
    }
  };

  onConfirmAction = (action) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => action(justification),
      },
    });
  }

  setValuesToStateGlobal = async () => {
    const { keysLenguages } = this.props;
    const { componentsAvailables, componentsSelected, selectedNavegationTree, selectedLabelNavegationTree } = this.state;

    const getValues = keysLenguages.reduce((accum, item) => {
      let values = this.state[item]
      values.titleSeccion = values.titleSeccion.trim()
      accum[item] = values;
      return accum;
    }, {});

    await store.dispatch({
      type: SET_VALUES_SECTION,
      payload: {
        general: getValues,
        componentsAvailables,
        componentsSelected,
        selectedNavegationTree,
        selectedLabelNavegationTree
      }
    });
    return true
  };

  onChangeComponent = (event) => {
    console.log('event', event)
    const { idSection } = this.props
    // START COMPONENT_CATEGORY_DOCUMENTS
    if (idSection === ID_SECTION_DOCUMENTS) {
      const isRemoveCategoryDocuments = event.source.find(item => item.componentName === COMPONENT_CATEGORY_DOCUMENTS)
      if (isRemoveCategoryDocuments) {
        event.source = event.source.filter(item => item.componentName !== COMPONENT_CATEGORY_DOCUMENTS)
        event.target.push(isRemoveCategoryDocuments)
      }
    }
    // END COMPONENT_CATEGORY_DOCUMENTS

    // START COMPONENT_FILTER_DOCUMENTS
    const isRemoveFilterDocuments = event.source.find(item => item.componentName === COMPONENT_FILTER_DOCUMENTS)
    if (isRemoveFilterDocuments) {
      event.source = event.source.filter(item => item.componentName !== COMPONENT_FILTER_DOCUMENTS)
      event.target.push(isRemoveFilterDocuments)
    }
    // END COMPONENT_FILTER_DOCUMENTS

    this.setState({
      componentsAvailables: event.source,
      componentsSelected: event.target,
    }, () => this.validateFieldsOnchange('componentsSelected', event.target));
  };

  itemTemplate = (item) => {
    const { t } = this.props
    return (
      <div className={classNames('product-item p-d-flex', {
                'product-item-required': item.componentName === COMPONENT_CATEGORY_DOCUMENTS || item.componentName === COMPONENT_FILTER_DOCUMENTS,
              })}>
        <div className="image-container p-pr-2" >
          {/* <img src={`/assets/img/banner-primary.png`} alt={item.name} style={{width: '100px'}}/> */}
          <img src={`${item.img}`} alt={item.name} style={{width: '150px'}}/>
        </div>
        <div className="product-list-detail">
          <h5 className="p-mb-2">{t(item.titleSection)}</h5>
          <span className="product-category">{t(item.description)}</span>
        </div>
      </div>
    )
  };

  sendIsOnlyFilterDocument = async (action, justification) => {
    const { generateLayoutsHtml } = this.props
    const { componentsAvailables, componentsSelected } = this.state
    await generateLayoutsHtml({
      componentsAvailables,
      componentsSelected
    })
    const isLanding = true
    return action(isLanding, justification)
  }
  

  render() {
    const { t, btnSubmitLoading, history, itemsTabsLenguages, keysLenguages, isEdit, finishAction, editable, idSection, idOriginalSection } = this.props;

    const {
      selectedNavegationTree,
      selectedLabelNavegationTree,
      activeTabIndex,
      loadingPage,
      componentsAvailables,
      componentsSelected,
      errors,
      isLanding,
      showModalJustification
    } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      const isDsabledSection =( idSection === SECTION_HOME_ID || idOriginalSection === SECTION_HOME_ID) && prefixLenguage === LANGUAGE_DEFAULT
      return (
        <>
          <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              {t('Titulo', {lng: prefixLenguage })}
            </label>
            <InputText
              name={`${prefixLenguage}-titleSeccion`}
              type="text"
              value={this.state[prefixLenguage].titleSeccion}
              onChange={this.onChange}
              autoFocus
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-titleSeccion`),
              })}
              disabled={isDsabledSection}
            />
            {getFormErrorMessage(`${prefixLenguage}-titleSeccion`)}
          </div>
          {/* <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              {t('Descripción', {lng: prefixLenguage })}
            </label>
            <InputTextarea
              name={`${prefixLenguage}-description`}
              rows={5}
              cols={30}
              value={this.state[prefixLenguage].description}
              onChange={this.onChange}
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-description`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-description`)}
          </div> */}
        </>
      );
    };

    const renderButtonContinue = () => {
      if (selectedNavegationTree === ID_SECTION_DOCUMENTS && (componentsSelected.length === 1 && componentsSelected[0].componentName === COMPONENT_FILTER_DOCUMENTS )  ) {
        return (
          // <Button
          //    label={t('Guardar')}
          //    type="button"
          //    onClick={() => this.onSubmit(null, () => this.sendIsOnlyFilterDocument(this.props.finishActionIsLanding), true)}
          //    className="p-button-primary"
          //    loading={btnSubmitLoading}
          //  />
          <SplitButton label={t('Guardar')} icon="pi pi-save" onClick={() => this.onSubmit(null, (justification) => this.sendIsOnlyFilterDocument(this.props.finishActionIsLanding, justification), true)} model={this.validateActionOnlyFilterDocument() }/>
        )
      }

      if (isLanding) {
        return (
          <Button
             label={t('Continuar')}
             type="submit"
             className="p-button-primary"
             loading={btnSubmitLoading}
           />
        )
      }
      return (
        // <Button
        //      label={t('Guardar')}
        //      type="button"
        //      onClick={() => this.onSubmit(null, () => finishAction())}
        //      className="p-button-primary"
        //      loading={btnSubmitLoading}
        //    />
        <SplitButton label={t('Guardar')} icon="pi pi-save" onClick={() => this.onSubmit(null, (justification) => finishAction(justification))} model={this.actions}/>
      )
    }

    if (loadingPage) return true;

    return (
      <>
        <form onSubmit={this.onSubmit} autoComplete="false">
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12 p-d-flex p-ai-center">
              <label className="p-text-bold p-mr-2">{t('Sección Padre')}</label>
              <div className={classNames({'is-display-none': isEdit})}>
                <CategoriesSectionTree
                  value={selectedNavegationTree}
                  label={selectedLabelNavegationTree}
                  onChangeCategorie={this.onChangeCategoriesSection}
                />
              </div>
              { isEdit && <a>{selectedLabelNavegationTree || "N/A"}</a> }
            </div>
            <div className="p-col-12" style={{marginTop: "-19px"}}>
            {getFormErrorMessage(`selectedNavegationTree`)}
            </div>
            <div className="p-col-12">
              {itemsTabsLenguages && (
                <TabMenu
                  model={itemsTabsLenguages}
                  activeIndex={activeTabIndex}
                  onTabChange={(e) => this.setState({ activeTabIndex: e.index })}
                />
              )}
            </div>
            {renderByTabLenguage()}
            { (isLanding || (isEdit && editable && isLanding)) && (
              <>
                <Divider type="dashed" />
                <div className="p-col-12">
                  <p className="p-text-bold p-mb-3">{t('Configuración')}</p>
                  <PickList
                    source={componentsAvailables}
                    target={componentsSelected}
                    itemTemplate={this.itemTemplate}
                    sourceHeader={t('Componentes Disponibles')}
                    targetHeader={t('Componentes Seleccionados')}
                    sourceStyle={{ height: '642px' }}
                    targetStyle={{ height: '642px' }}
                    onChange={this.onChangeComponent}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`componentsSelected`),
                    })}
                  />
                  {getFormErrorMessage(`componentsSelected`)}
                </div>
              </>
            )}
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Cancelar')}
                type="button"
                className="p-button-secondary"
                onClick={() => history.push('/sections')}
              />
              { renderButtonContinue() }
              {/* { isLanding 
              ? (
                  <Button
                    label={t('Continuar')}
                    type="submit"
                    className="p-button-primary"
                    loading={btnSubmitLoading}
                  />
              ) 
              : (
                <Button
                    label={t('Guardar')}
                    type="button"
                    onClick={() => this.onSubmit(null, () => finishAction())}
                    className="p-button-primary"
                    loading={btnSubmitLoading}
                  />
              )
              } */}
                {/* <SplitButton label={t('Guardar')} icon="pi pi-save" onClick={() => this.onSubmit(null, () => finishAction())} model={isEdit ? this.actionsEdit : this.actions}/> */}
            </div>
          </div>
        </form>
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.setState({showModalJustification: { isVisible: false }})}
          onContinueAction={showModalJustification.continueAction}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  _componentsAvailables: state.section.componentsAvailables,
  _componentsSelected: state.section.componentsSelected,
  _general: state.section.general,
  _selectedNavegationTree: state.section.selectedNavegationTree,
  editable: state.section.editable,
  idSection: state.section.id,
  idOriginalSection: state.section.id_original,
  estatusSection: state.section.estatus
});

const mapDispatchToProps = {
  generateLayoutsHtml,
  validatePermissionAction
};


export default withRouter(compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(GeneralForm));
